// import _debounce from "lodash.debounce"
import _debounce from 'lodash/debounce';

export default function debounce(func) {
  return _debounce(
    func,
    500,
    {
      leading: true,
      trailing: false,
    },
  );
}
